import React from "react";
import { PropTypes } from "prop-types";

const SpotifyIcon = ({ size, color, children, ...props }) => (
  <svg {...props} viewBox="0 0 24 24" width={size} height={size} fill={color}>
    {children}
    <g
      id="Logos/Social/Fill/Spotify-24"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <polygon id="Fill-1" points="0 0 24 0 24 24 0 24" />
      <path
        d="M17.9153601,10.8652186 C14.6919265,8.95090933 9.37494477,8.77489462 6.29779205,9.70882342 C5.80354179,9.85880611 5.28099065,9.57985742 5.13124679,9.08572657 C4.98150293,8.59123748 5.26021279,8.06904458 5.75470189,7.91882307 C9.28705683,6.84661405 15.1591894,7.05367613 18.8700668,9.25648711 C19.3145218,9.52038976 19.460325,10.0944079 19.1969,10.5381465 C18.9332362,10.9826015 18.3587404,11.1291212 17.9153601,10.8652186 Z M17.809799,13.70056 C17.5836309,14.0675161 17.1038296,14.1826302 16.7373512,13.9572979 C14.0499624,12.3054584 9.95206764,11.8268512 6.77269742,12.7919468 C6.36036445,12.9164945 5.92498477,12.6841169 5.79972057,12.2725004 C5.67553109,11.8602868 5.90802813,11.4256236 6.31964463,11.30024 C9.95158998,10.1980583 14.4667136,10.7318343 17.5533,12.6287093 C17.9197784,12.8543998 18.0351313,13.3344399 17.809799,13.70056 Z M16.5861744,16.4235339 C16.4064579,16.7182451 16.022784,16.8105513 15.7291475,16.6309542 C13.3808915,15.1957298 10.4251818,14.871643 6.94429385,15.6666945 C6.60886283,15.7435965 6.27450653,15.5334297 6.19796281,15.1979986 C6.12118028,14.862687 6.33063062,14.5283307 6.66677812,14.451787 C10.4760517,13.5810277 13.7435487,13.9557456 16.3793511,15.5663876 C16.6732264,15.7458653 16.7657715,16.129778 16.5861744,16.4235339 Z M12,2 C6.47726974,2 2,6.47715033 2,11.9998806 C2,17.5232079 6.47726974,22 12,22 C17.5229691,22 22,17.5232079 22,11.9998806 C22,6.47715033 17.5229691,2 12,2 L12,2 Z"
        id="Spotify_Icon_RGB_Black"
        fill={color}
      />
    </g>
  </svg>
);

SpotifyIcon.displayName = "SpotifyIcon";

SpotifyIcon.defaultProps = {
  color: "currentColor",
  children: null
};

SpotifyIcon.propTypes = {
  size: PropTypes.number.isRequired,
  color: PropTypes.string,
  children: PropTypes.node
};

export default SpotifyIcon;
